import { render, staticRenderFns } from "./ViewAiBusinessPromoter.vue?vue&type=template&id=2b1127d5&scoped=true&"
import script from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./ViewAiBusinessPromoter.vue?vue&type=style&index=0&id=2b1127d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1127d5",
  null
  
)

export default component.exports